module.exports = "<div>Non hai a disposizione tutti i dati necessari per la compilazione della richiesta di fornitura online o vuoi completarla più tardi? Riceverai un’email con un link che ti permetterà di riprendere la compilazione della richiesta dallo step in cui ti sei fermato senza perdere i dati inseriti.</div>\n<!-- <div>{{currentOnBoarding.email}}</div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-attivazioni/dialogs/alg-attivazioni-stop-modal/alg-attivazioni-stop-modal.component.html
// module id = ./src/app/components/alg-attivazioni/dialogs/alg-attivazioni-stop-modal/alg-attivazioni-stop-modal.component.html
// module chunks = main